




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { mapGetters } from 'vuex'

import AuthorizationMixin from '@/routing/AuthorizationMixin'
import PtsdMixin from '../PtsdMixin'

export default mixins(AuthorizationMixin, PtsdMixin).extend({
  computed: {
    ...mapGetters('workflow', ['isDone']),
    patient(): any {
      return this.$store.getters.currentCase.patient
    },
    genderOfPatient(): string | null {
      const patient = this.patient
      return patient.gender && patient.gender.toLowerCase()
    },
    nameOfPatient(): string | null {
      const patient = this.patient
      return patient.alias
    },
    genderOfTherapist(): string | null {
      const therapists: any[] = this.$store.getters.currentCase.members.filter(
        o => o.acts_as_therapist
      )
      return therapists.length > 0 && therapists[0].gender && therapists[0].gender.toLowerCase()
    },
  },
  data() {
    const inTwoDays = new Date()
    inTwoDays.setDate(inTwoDays.getDate() + 2)
    return {
      agreedToAntiSuicideContract: false,
      emergencyContact: '',
      daysUntilP5: inTwoDays,
      addresseeOfP5: null,
    }
  },
})
